import { memo, useCallback } from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import {
	MuiDateTimePicker
} from '../../../../shared/ui/MuiDateTimePicker/MuiDateTimePicker'
import { toUTCISOString } from '../../../../shared/lib/DateAndTieHelpers/toUTCISOString'
import { fromUTCISOString } from '../../../../shared/lib/DateAndTieHelpers/fromUTCString'
import { FilterApply } from '../../../../shared/ui/FilterApply/FilterApply'
import { selectLicenseId } from '../../../License'
import { licenseUpdatesActions } from '../../model/slices/licenseUpdatesSlice'
import { fetchLicenseUpdates } from '../../model/services/fetchLicenseUpdates'
import {
	selectUpdateTimeFrom,
	selectUpdateTimeTo
} from '../../model/selectors/selectFilters'

const inputStyles = { width: '16rem' }

export const LicenseUpdatesFilter = memo(function LicenseUpdatesFilter() {
	const dispatch = useAppDispatch()
	const licenseId = useAppSelector(selectLicenseId)

	const storedUpdateTimeFrom = useAppSelector(selectUpdateTimeFrom)
	const updateTimeFrom = storedUpdateTimeFrom ? fromUTCISOString(storedUpdateTimeFrom) : null

	const storedUpdateTimeTo = useAppSelector(selectUpdateTimeTo)
	const updateTimeTo = storedUpdateTimeTo ? fromUTCISOString(storedUpdateTimeTo) : null

	const handleApply = useCallback(() => {
		dispatch(licenseUpdatesActions.setPage(1))
		dispatch(licenseUpdatesActions.setQueryFilter())
		dispatch(fetchLicenseUpdates(licenseId))
	}, [dispatch, licenseId])

	const handleUpdateTimeFromChange = (value: Date | null) => {
		const formatedValue = value instanceof Date ? toUTCISOString(value) : null
		dispatch(licenseUpdatesActions.setUpdateTimeFrom(formatedValue))
	}

	const handleUpdateTimeToChange = (value: Date | null) => {
		const formatedValue = value instanceof Date ? toUTCISOString(value) : null
		dispatch(licenseUpdatesActions.setUpdateTimeTo(formatedValue))
	}

	return (
		<Stack
			spacing={2}
			direction="row"
			sx={{ my: 2 }}
		>
			<MuiDateTimePicker
				value={updateTimeFrom}
				onChange={handleUpdateTimeFromChange}
				label={'Update time from'}
			/>
			<MuiDateTimePicker
				value={updateTimeTo}
				onChange={handleUpdateTimeToChange}
				label={'Update time to'}
			/>
			<Box sx={inputStyles}>
				<FilterApply handleApply={handleApply} />
			</Box>
		</Stack>
	)
})